import ReactApexChart from 'react-apexcharts'
import {
  getAlarmMetersData,
  getChartDataForMeterAlarms,
  getDailyChartDataForMeterAlarms,
} from './core/_requests'
import { useEffect, useState } from 'react'
import { AlarmChartDataType } from './core/_model'
import { useIntl } from 'react-intl'

function MetersForAlarmCommentModal(alarmSite: any) {
  let site = alarmSite.siteValue
  let date = alarmSite.dateValue
  let alert_type = alarmSite.alert_type
  let [data, setData] = useState<AlarmChartDataType>({
    labels: [],
    datasets: [],
  })

  let [dailyData, setDailyData] = useState<any>({
    labels: [],
    datasets: [],
  })

  let [info, setInfo] = useState([])
  let [dailyInfo, setDailyInfo] = useState([])

  const intl = useIntl()

  const fetchAlarmChartData = async () => {
    try {
      setTimeout(async () => {
        const data = await getChartDataForMeterAlarms(site, date, alert_type)
        setData(data)
      }, 2000)
    } catch (error) {
      console.error('Error fetching alarm chart data:', error)
    }
  }

  const fetchDailyAlarmChartData = async () => {
    try {
      setTimeout(async () => {
        const data = await getDailyChartDataForMeterAlarms(site, date)
        setDailyData(data)
      }, 2000)
    } catch (error) {
      console.error('Error fetching alarm chart data:', error)
    }
  }

  console.log('dailyData', dailyData)

  const fetchAlarmMetersData = async () => {
    try {
      setTimeout(async () => {
        const info = await getAlarmMetersData(site, date, alert_type)
        if (alert_type === 'daily') {
          setDailyInfo(info)
        } else {
          setInfo(info)
        }
      }, 2000)
    } catch (error) {
      console.error('Error fetching alarm chart data:', error)
    }
  }

  useEffect(() => {
    if (site && date && alert_type === 'hourly') {
      fetchAlarmChartData()
      fetchAlarmMetersData()
    } else if (site && date && alert_type === 'daily') {
      fetchDailyAlarmChartData()
      fetchAlarmMetersData()
    }
  }, [site, date, alert_type])

  let seriesData: any = []
  let chartData: any = data
  let meterInfo: any = info
  let meterIds: string[] = []

  if (alert_type === 'daily') {
    chartData = dailyData
    meterInfo = dailyInfo
  }

  if (chartData.datasets && Array.isArray(chartData.datasets)) {
    chartData.datasets.map((dataset: any, index: number) => {
      seriesData[index] = dataset
    })
  } else if (chartData.datasets && typeof chartData.datasets === 'object') {
    meterIds = Object.keys(chartData.datasets)
    meterIds.forEach((meterId, index) => {
      seriesData[index] = chartData.datasets[meterId]
    })
  }

  return (
    <div style={{ margin: '10px' }}>
      {chartData.datasets && seriesData.length > 0 && meterInfo && meterInfo.length > 0 ? (
        <div className='accordion' id='kt_accordion_1'>
          {seriesData.map((dataset: any, index: number) => (
            <div key={index}>
              {meterInfo[index] && (
                <div className='accordion-item' key={index}>
                  <h2 className='accordion-header' id={`kt_accordion_1_header_${index}`}>
                    <button
                      className='accordion-button fs-4 fw-bold collapsed'
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target={`#kt_accordion_1_body_${index}`}
                      aria-expanded='false'
                      aria-controls={`kt_accordion_1_body_${index}`}
                    >
                      {meterInfo[index]['code']}
                    </button>
                  </h2>
                  <div
                    id={`kt_accordion_1_body_${index}`}
                    className='accordion-collapse collapse'
                    aria-labelledby={`kt_accordion_1_header_${index}`}
                    data-bs-parent='#kt_accordion_1'
                  >
                    <div className='accordion-body'>
                      <ReactApexChart
                        options={{
                          chart: {
                            zoom: {
                              enabled: true,
                            },
                            dropShadow: {
                              enabled: true,
                              color: '#000',
                              top: 18,
                              left: 7,
                              blur: 10,
                              opacity: 0.2,
                            },
                          },
                          dataLabels: {
                            enabled: false,
                          },
                          markers: {
                            size: 2,
                            strokeWidth: 0,
                            fillOpacity: 1,
                          },
                          stroke: {
                            curve: 'smooth' as const,
                          },
                          xaxis: {
                            categories: chartData.labels,
                            tickAmount: 12,
                            labels: {
                              style: {
                                fontSize: '12px',
                              },
                            },
                            axisTicks: {
                              show: true,
                              borderType: 'solid',
                              color: '#78909C',
                              height: 6,
                              offsetX: 0,
                              offsetY: 0,
                            },
                          },
                          legend: {
                            show: true,
                            position: 'top',
                            horizontalAlign: 'left',
                            fontSize: '12px',
                            fontFamily: 'Inter, sans-serif',
                            markers: {
                              width: 12,
                              height: 12,
                              radius: 6,
                            },
                          },
                        }}
                        series={seriesData && seriesData[index] ? seriesData[index] : []}
                        height={200}
                        type='line'
                      />
                    </div>
                    <table className='table table-row-dashed table-row-gray-300 gy-7'>
                      <thead>
                        <tr className='fw-bolder fs-6 text-gray-800'>
                          <th>{intl.formatMessage({ id: 'ALARMS.DATE' })}</th>
                          <th>{intl.formatMessage({ id: 'ALARMS.COMPANYSITE' })}</th>
                          <th>{intl.formatMessage({ id: 'ALARMS.METERID' })}</th>
                          <th>{intl.formatMessage({ id: 'ALARMS.METERTYPE' })}</th>
                          <th>{intl.formatMessage({ id: 'ALARMS.METERCODE' })}</th>
                          <th>{intl.formatMessage({ id: 'ALARMS.TOTALCONSUMPTION' })}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr key={index}>
                          <td key={index + 'date'}>
                            {meterInfo[index] && meterInfo[index]['date']
                              ? meterInfo[index]['date']
                              : 'N/A'}
                          </td>
                          <td key={index + 'name'}>
                            {meterInfo[index] && meterInfo[index]['name']
                              ? meterInfo[index]['name']
                              : 'N/A'}
                          </td>
                          <td key={index + 'meterId'}>
                            {meterInfo[index] && meterInfo[index]['meterId']
                              ? meterInfo[index]['meterId']
                              : 'N/A'}
                          </td>
                          <td key={index + 'meterType'}>
                            {meterInfo[index] && meterInfo[index]['meter_type']
                              ? meterInfo[index]['meter_type']
                              : 'N/A'}
                          </td>
                          <td key={index + 'code'}>
                            {meterInfo[index] && meterInfo[index]['code']
                              ? meterInfo[index]['code']
                              : 'N/A'}
                          </td>
                          <td key={index + 'total'}>
                            {meterInfo[index] && meterInfo[index]['total']
                              ? meterInfo[index]['total'] + ' kWh'
                              : 'N/A'}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}

export default MetersForAlarmCommentModal
